//MARK: Done
export const AUDIT = {
    AUDIT: {
      PAGE: "audit/page",
    },
  };
  